import ServerCommunicator from './ServerCommunicator';

/**
 * Acts as a Facade to the Tweeter server. All network requests to the server go through this class.
 */

class ServerFacade {

	// GET
	static async getUserInstance(): Promise<any> {
		const urlPath = 'user/me';

		const request = {
			headers: {
				'Content-Type': 'application/json'
			},
			method: 'GET',
		};
		try {
			return await ServerCommunicator.doRequest(request, urlPath);
		} catch(err) {
			console.log(err);
		}
	}

	// DELETE
	static async userLogout(): Promise<any> {
		const urlPath = 'logout';

		const request = {
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'DELETE',
        };
		try {
			return await ServerCommunicator.doRequest(request, urlPath, false);
		} catch(err) {
			console.log(err);
		}
	}

	static async getActiveSubscription(id : string): Promise<any> {
		const urlPath = 'user/' + id + '/subscriptions';

		const request = {
			headers: {
				'Content-Type': 'application/json'
			},
			method: 'GET',
		};
		try {
			return await ServerCommunicator.doRequest(request, urlPath);
		} catch(err) {
			console.log('Caught error getting user subscriptions', err);
		}
	}

	static async getConfigs(): Promise<any> {
		const urlPath = 'config/premium-site';

		const request = {
			headers: {
				'Content-Type': 'application/json'
			},
			method: 'GET',
		};
		return ServerCommunicator.doRequest(request, urlPath);
	}
}

export default ServerFacade;
